<template>
  <a-modal
    v-model="showModal"
    :title="title"
    width="68%"
    :footer="null"
    :maskClosable="false"
    :dialogStyle="{ top: '15%' }"
    @cancel="handleCancel"
  >
    <div style="height: 180px">
      <div class="refund_info">
        <div>
          <span class="refund_info_label">订单编号：</span>
          <span>{{ record.order }}</span>
        </div>
        <div style="margin-left: 20px">
          <span class="refund_info_label">TSID：</span>
          <span>{{ record.tsid }}</span>
        </div>
        <div style="margin-left: 20px" v-if="record.begin">
          <span class="refund_info_label">起始使用时间：</span>
          <span>{{ record.begin }}</span>
        </div>
        <div style="margin-left: 20px" v-if="record.end">
          <span class="refund_info_label">结束使用时间：</span>
          <span>{{ record.end }}</span>
        </div>
      </div>
      <div style="margin-top: 30px; display: flex; align-items: center">
        <span class="refund_info_label" style="width: 120px"
          >申请退款原因：</span
        >
        <a-textarea
         v-model.trim="reason"
          style="margin-left:6px; height:80px;resize:none;"
          :maxLength="150"
          placeholder="请输入退款原因"
          autocomplete="off"
        />
      </div>
      <div style="margin-top: 30px">
        <span class="refund_confirm" @click.prevent="confirm">确定</span>
        <span class="refund_cancel" @click.prevent="cancel">取消</span>
      </div>
    </div>
  </a-modal>
</template>
<script>
import {errMsg, warnMsg, successMsg, isNull} from "../../../utils/CommonUtils.js"
export default {
  props: ["record"],
  data() {
    return {
      title: "退款",
      showModal: false,
      reason: "",
    };
  },
  created() {
    this.showModal = true;
  },
  methods: {
    handleCancel() {
      this.showModal = false;
      this.$emit("refund-visible", false, 0);
    },
    confirm() {
      if(isNull(this.reason)){
        warnMsg("请输入退款原因")
        return;
      }
      this.axios.post(this.baseUrl +"afterrefund_order?tsid=" + this.record.tsid + "&orderid=" + 
          this.record.id + "&orderNumber=" + this.record.order+"&reason="+this.reason,"", 
          { headers: { token: sessionStorage.getItem("token") } }
        ).then((res) => {
          if (res.status == 200) {
            if (res.data.code == 0) {
              successMsg("退款申请中");
              this.$emit("refund-visible", false, 1);
              this.showModal = false;
            } else if (res.data.code == -1) {
              warnMsg("请先登录");
              setTimeout(() => {
                this.$router.push({ name: "login" });
              }, "2000");
            } else if (res.data.code == -2) {
              warnMsg("退订失败");
            } else if (res.data.code == -3) {
              warnMsg("没有操作权限");
            } else if (res.data.code == -4) {
              warnMsg("该订单无法退款");
            }else if (res.data.code == -7) {
              errMsg("系统异常,请联系客服");
            }
          } else {
            errMsg("操作失败,请稍后重试");
          }
        }).catch(() => {
          errMsg("系统异常,请联系客服");
        });
    },
    cancel() {
      this.showModal = false;
      this.$emit("refund-visible", false, 0);
    },
  },
};
</script>
<style scoped>

.refund_info {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.refund_info_label {
  color: rgb(48, 48, 48);
  font-weight: 600;
}

.refund_cancel,
.refund_confirm {
  float: right;
  border-radius: 5px;
  text-align: center;
  display: block;
  height: 33px;
  width: 60px;
  line-height: 33px;
}
.refund_cancel {
  margin-right: 15px;
  border: 1px solid rgb(184, 184, 184);
}
.refund_cancel:hover {
  cursor: pointer;
  border: 1px solid rgb(78, 78, 255);
  color: rgb(78, 78, 255);
}
.refund_confirm {
  border: 1px solid rgb(78, 78, 255);
  background-color: rgb(78, 78, 255);
  color: white;
}
.refund_confirm:hover {
  cursor: pointer;
  box-shadow: 0px 0px 2px 0px rgb(23, 23, 255);
}
</style>